import React from 'react';
import { PublicLayout } from '../components/PublicLayout';
import { MapPin, Mail, Phone, Clock, ArrowRight, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const contactItems = [
  {
    icon: <MapPin size={18} />,
    label: 'Alamat Sekretariat',
    value: 'Ibu Pejabat Rumpun Silat Sarawak, Sarawak',
    sub: 'Alamat lengkap — sila hubungi untuk maklumat terkini',
  },
  {
    icon: <Phone size={18} />,
    label: 'Telefon',
    value: 'Hubungi Sekretariat RSS',
    sub: 'Untuk nombor terkini, hantar pertanyaan melalui emel',
  },
  {
    icon: <Mail size={18} />,
    label: 'Emel Rasmi',
    value: 'Sekretariat RSS Sarawak',
    sub: 'Untuk pertanyaan rasmi dan pendaftaran',
  },
  {
    icon: <Clock size={18} />,
    label: 'Waktu Pejabat',
    value: 'Isnin – Jumaat',
    sub: '8:00 pagi – 5:00 petang (kecuali hari cuti umum)',
  },
];

const enquiries = [
  { title: 'Pendaftaran Perguruan Baru', link: '/register-school', linkLabel: 'Daftar Sekarang' },
  { title: 'Status Permohonan Keahlian', link: '/portal-ahli', linkLabel: 'Log Masuk Portal' },
  { title: 'Pengesahan / Verifikasi Rekod Pesilat', link: '/direktori-pesilat', linkLabel: 'Direktori Pesilat' },
  { title: 'Maklumat Pertandingan & Program', link: '/aktiviti', linkLabel: 'Lihat Aktiviti' },
  { title: 'Pertanyaan Am Tentang RSS Sarawak', link: '/tentang-rss', linkLabel: 'Tentang RSS' },
  { title: 'Kerjasama & Perkongsian Program', link: null, linkLabel: null },
];

export default function Hubungi() {
  return (
    <PublicLayout>
      {/* Page Header */}
      <div className="bg-[#0B0B0B] text-white py-16">
        <div className="h-0.5 bg-gradient-to-r from-[#D71920] via-[#FFD21F] to-[#D71920] -mt-16 mb-16" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <p className="text-xs text-[#FFD21F] font-bold tracking-widest uppercase mb-3">Utama / Hubungi</p>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold" data-testid="hubungi-title">Hubungi Kami</h1>
          <p className="text-[#999] mt-3 text-sm sm:text-base max-w-lg">
            Untuk sebarang pertanyaan mengenai Rumpun Silat Sarawak, sila hubungi Sekretariat kami.
          </p>
        </div>
      </div>

      <section className="bg-white py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid lg:grid-cols-2 gap-14">

            {/* Contact Info */}
            <div>
              <div className="text-xs font-bold tracking-widest text-[#D71920] uppercase mb-4">Maklumat Hubungan</div>
              <h2 className="text-2xl font-extrabold text-[#0B0B0B] mb-8">Sekretariat RSS Sarawak</h2>
              <div className="space-y-4">
                {contactItems.map((c, i) => (
                  <div key={i} className="flex items-start gap-4 p-5 bg-[#F7F7F7] rounded border border-[#E5E5E5]" data-testid={`contact-info-${i}`}>
                    <div className="w-9 h-9 bg-[#D71920]/8 rounded flex items-center justify-center text-[#D71920] flex-shrink-0">
                      {c.icon}
                    </div>
                    <div>
                      <p className="text-xs font-bold text-[#0B0B0B] uppercase tracking-wide mb-0.5">{c.label}</p>
                      <p className="text-sm font-semibold text-[#0B0B0B]">{c.value}</p>
                      <p className="text-xs text-[#777] mt-0.5">{c.sub}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Registration note */}
              <div className="mt-6 p-5 bg-[#0B0B0B] text-white rounded">
                <p className="text-xs text-[#FFD21F] font-bold tracking-widest uppercase mb-2">Pendaftaran Digital</p>
                <p className="text-sm text-[#999] leading-relaxed mb-4">
                  Untuk urusan pendaftaran perguruan atau ahli, sila gunakan portal digital RSS Sarawak.
                </p>
                <div className="flex flex-wrap gap-3">
                  <Link to="/register-school" className="text-[#FFD21F] text-xs font-bold hover:underline flex items-center gap-1">
                    Daftar Perguruan <ArrowRight size={11} />
                  </Link>
                  <Link to="/register-member" className="text-[#FFD21F] text-xs font-bold hover:underline flex items-center gap-1">
                    Daftar Ahli <ArrowRight size={11} />
                  </Link>
                </div>
              </div>
            </div>

            {/* Enquiry Types */}
            <div>
              <div className="text-xs font-bold tracking-widest text-[#D71920] uppercase mb-4">Jenis Pertanyaan</div>
              <h2 className="text-2xl font-extrabold text-[#0B0B0B] mb-8">Boleh Kami Bantu Dengan</h2>
              <div className="space-y-2">
                {enquiries.map((item, i) => (
                  <div key={i} className="flex items-center justify-between gap-3 py-4 border-b border-[#F7F7F7]" data-testid={`enquiry-item-${i}`}>
                    <div className="flex items-center gap-3">
                      <div className="w-1.5 h-1.5 bg-[#D71920] rounded-full flex-shrink-0" />
                      <span className="text-sm text-[#555]">{item.title}</span>
                    </div>
                    {item.link && (
                      <Link to={item.link} className="text-xs font-semibold text-[#D71920] hover:underline whitespace-nowrap flex items-center gap-1">
                        {item.linkLabel} <ChevronRight size={11} />
                      </Link>
                    )}
                  </div>
                ))}
              </div>

              {/* Wilayah Contact note */}
              <div className="mt-8 p-5 bg-[#FFFBF0] border border-[#D4AF37]/30 rounded">
                <p className="text-xs font-bold text-[#0B0B0B] mb-2 uppercase tracking-wide">Hubungi Pengerusi Wilayah</p>
                <p className="text-sm text-[#7a6200] leading-relaxed">
                  Untuk pertanyaan yang berkaitan dengan aktiviti wilayah atau perguruan di kawasan anda,
                  sila rujuk <Link to="/wilayah" className="font-semibold text-[#D71920] hover:underline">senarai pengerusi wilayah RSS</Link>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
